import { COLORS } from '../../constants/theme';

interface ToggleProps {
  enabled: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export function Toggle({ enabled, onChange, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={onChange}
      disabled={disabled}
      style={{
        width: 30,
        height: 16,
        borderRadius: 8,
        padding: 2,
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        background: enabled ? COLORS.link : COLORS.border,
        transition: 'background 0.2s',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <div
        style={{
          width: 12,
          height: 12,
          borderRadius: 6,
          background: enabled ? '#fff' : COLORS.text.muted,
          transform: enabled ? 'translateX(14px)' : 'translateX(0px)',
          transition: 'transform 0.2s',
        }}
      />
    </button>
  );
}
